module.exports = __webpack_public_path__ + "static/media/mstile-150x150.e36be22f.png";